import {
  Component,
  OnInit,
  ApplicationRef,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {OrdersService, OrderFilter} from '../../data/orders.service';
import {Order} from '../../data/order';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {OrderModalComponent} from '../order-modal/order-modal.component';
import {ProjectWindowComponent} from '../../../project/view/project-window/project-window.component';
import {VendorModalComponent} from '../../../vendor/view/vendor-modal/vendor-modal.component';
import {trackEntityById} from 'projects/core/src/public-api';
import {OrderItem} from '../../data/order-item';
import {Vendor} from '../../../vendor/data/vendor';
import {VendorsService} from '../../../vendor/data/vendors.service';
import {ProjectStatus} from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ConfirmationService, LazyLoadEvent} from 'primeng/api';
import {OrderPdfPreviewDialogComponent} from '../order-pdf-preview-dialog/order-pdf-preview-dialog.component';
import {Paginator} from 'primeng/paginator';
import {LocalStorage} from 'ngx-webstorage';
import {Router} from '@angular/router';
import {ShortObject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import {timer} from 'rxjs';
import {ShortProject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

export class OrderToSubmit {
  id: number;
  order: Order;
  selected: boolean;
}


@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
  styleUrls: ['./orders-page.component.scss'],
  providers: [ConfirmationService]
})
export class OrdersPageComponent implements OnInit, AfterViewInit {

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  orders: Order[];
  selectedOrder: Order;

  trackEntityById = trackEntityById;

  vendorsShowAll = true;
  statusesShowAll = true;

  ordersToSubmit: OrderToSubmit[] = [];
  selectedToSubmitCounter = 0;
  submitCounter: number;

  @LocalStorage()
  vendorIds: number[];

  @LocalStorage()
  statusesIds: number[];

  vendors: ShortObject[] = [];
  selectedVendors: ShortObject[];

  statuses: ProjectStatus[];
  selectedStatuses: ProjectStatus[];

  ordersLoading: boolean;
  firstLoading: boolean;

  @LocalStorage()
  ordersProjectId: number;

  ordersProject: ShortProject;

  ordersProjects: ShortProject[] = [];
  ordersProjectLoading: boolean;

  loadingSpinner: boolean;

  openedOrders: number[] = [];

  vendorFiltersLabel = 'Filter Vendors';
  statusesFiltersLabel = 'Order Statuses';

  buttonLoading: boolean;
  saveLoading = -1;
  deleteLoading = -1;

  orderFilter: OrderFilter = {};

  ordersPerPage = 15;

  totalRecords: number;
  @ViewChild('orderPaginator', {static: false}) paginator: Paginator;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private ordersService: OrdersService,
    protected vendorsService: VendorsService,
    protected confirmationService: ConfirmationService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected appRef: ApplicationRef,
    protected el: ElementRef
  ) {
  }

  ngOnInit() {
    this.firstLoading = true;
  }

  getOrders() {
    this.orderFilter.start = [0]
    this.orderFilter.limit = [100];

    this.ordersService.getOrderFilters().subscribe(filters => {
      this.processFilterVendors(filters.vendors)

      this.processFilterProjects(filters.projects)

      this.processFilterStatuses(filters.statuses)

      this.getOrdersLazy(0, this.ordersPerPage);

    })
  }

  processFilterVendors(vendors: ShortObject[]) {
    let noVendor = {
      id: 0,
      name: 'No Vendor'
    }
    this.vendors = [noVendor, ...vendors]
    this.selectedVendors = [...this.vendors]

    if (this.vendorIds?.length > 0 && this.vendorIds?.length < this.vendors.length) {
      this.selectedVendors = this.vendors.filter(vend => this.vendorIds.includes(vend.id))
      this.orderFilter.vendors = this.vendorIds;
    }


    if (this.selectedVendors) {
      this.vendorFiltersLabel = this.selectedVendors.length + ' vendors selected';
    }
  }

  processFilterStatuses(statuses: ShortObject[]) {
    this.statuses = statuses
    this.selectedStatuses = [...this.statuses]

    if (this.statusesIds?.length > 0 && this.statusesIds?.length < this.statuses.length) {
      this.selectedStatuses = this.statuses.filter(stat => this.statusesIds.includes(stat.id))
      this.orderFilter.statuses = this.statusesIds;
    }


    if (this.selectedStatuses) {
      this.statusesFiltersLabel = this.selectedStatuses.length + ' statuses selected';
    }
  }

  processFilterProjects(projects: ShortProject[]) {
    this.ordersProjects = projects;

    if (this.ordersProjectId > 0) {
      const fProj = this.ordersProjects.find(proj => proj.id === this.ordersProjectId)

      if (fProj) {
        this.ordersProject = fProj;
        this.orderFilter.project = [this.ordersProjectId];
      }
    }
  }

  updateOrders(action?: string) {

    const openedOrdersMap = new Map()

    this.openedOrders.forEach(id => {
      openedOrdersMap.set(this.ordersToSubmit[id].order.id, id)
    })

    this.ordersService.getFilteredOrders(this.orderFilter).subscribe(orders => {
      this.ordersToSubmit = orders.content.map(order => ({
        id: order.id,
        order,
        selected: false
      }))
      this.openedOrders = [];
      this.ordersToSubmit.forEach((order, index) => {
        if (openedOrdersMap.has(order.order.id)) {
          this.openedOrders.push(index)
        }
      })

      this.updateCost()

      if (action === 'CREATE') {
        this.openedOrders.unshift(0)
      }
    })
  }

  getOrdersLazy(page: number, rows: number) {
    this.openedOrders = [];

    this.ordersLoading = true;
    this.selectedToSubmitCounter = 0;

    this.orderFilter.start = [page]
    this.orderFilter.limit = [rows];

    this.ordersService.getFilteredOrders(this.orderFilter).subscribe(orders => {
      this.ordersToSubmit = orders.content.map(order => ({
        id: order.id,
        order,
        selected: false
      }))

      this.totalRecords = orders.totalElements;


      this.updateCost()

      this.firstLoading = false;
      this.ordersLoading = false;
    })
  }

  submitOrder(order: Order, event) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(OrderPdfPreviewDialogComponent, {
      data: {
        orderId: order.id,
        dialogHeader: order.number + ' - ' + order.project.name,
        link: '/orders/' + order.id + '/pdf',
        showSendButton: true
      },
      panelClass: 'order-pdf-preview-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== 'close-button') {
        const forder = this.ordersToSubmit.find(frder => frder.order.id === result.id);
        if (forder) {
          forder.order = result;
        }

        this.updateOrders();
      }
    });
  }

  openSnackBar(message: string, duration = 5000, type: string) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: type + '-snackbar',
      verticalPosition: 'top',
    });
  }

  createNewOrder() {
    const dialogRef = this.dialog.open(OrderModalComponent, {
      data: {
        order: null,
        buttonLabel: 'Create',
        projectId: this.ordersProject ? this.ordersProject.id : null
      },
      panelClass: 'order-modal-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== 'close-button') {
        this.updateOrders('CREATE');
      }
    });
  }

  openOrderTab(event) {
    this.openedOrders.push(event.index)
    this.ordersService.openedOrderSubj$.next(this.ordersToSubmit[event.index].order.id)
    // this.getStockInfo(this.ordersToSubmit[event.index].order.id, event.index)
  }

  closeOrderTab(event) {
    const openedOrder = this.openedOrders.findIndex(i => i === event.index)

    if (openedOrder >= 0) {
      this.openedOrders.splice(openedOrder, 1)
    }
  }

  openOrder(order: Order) {
    const dialogRef = this.dialog.open(OrderModalComponent, {
      data: {
        order,
        buttonLabel: 'Save'
      },
      panelClass: 'order-modal-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== 'close-button') {
        const forder = this.ordersToSubmit.find(frder => frder.order.id === result.id);
        if (forder) {
          forder.order = result;
        }

        this.updateOrders();
      }
    });
  }

  confirmOrder(order: Order) {
    const dialogRef = this.dialog.open(OrderModalComponent, {
      data: {
        order,
        buttonLabel: 'Confirm'
      },
      panelClass: 'order-modal-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== 'close-button') {
        const forder = this.ordersToSubmit.find(frder => frder.order.id === result.id)
        forder.order = result;

        if (forder) {
          forder.order = result;
        }

        this.updateOrders();
      }

    });
  }

  acceptDelivery(order: Order) {
    const dialogRef = this.dialog.open(OrderModalComponent, {
      data: {
        order,
        buttonLabel: 'Accept'
      },
      panelClass: 'order-modal-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== 'close-button') {
        const forder = this.ordersToSubmit.find(frder => frder.order.id === result.id)
        forder.order = result;

        if (forder) {
          forder.order = result;
        }

        this.updateOrders();
      }

    });
  }

  openProjectWindow(projectId: number) {
    const dialogRef = this.dialog.open(ProjectWindowComponent, {
      data: {
        projectNumber: projectId,
      },
      panelClass: 'project-window-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openVendor(vendorId: number) {
    const dialogRef = this.dialog.open(VendorModalComponent, {
      data: vendorId,
      panelClass: 'vendor-modal-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  updateCost() {
    this.ordersToSubmit.forEach(orderToSubmit => {
      let total = 0;
      orderToSubmit.order.items.forEach(item => {
        total += item.price * item.orderedQuantity
        total += item.price * item.reservedQuantity
      })
      orderToSubmit.order.total = total;
    })
  }

  updateFilter() {
    this.orderFilter.start = [0];
    this.orderFilter.limit = [15];

    if (this.selectedVendors) {
      this.orderFilter.vendors = this.selectedVendors.map(t => t.id);
      this.vendorIds = [...this.orderFilter.vendors];

      this.vendorFiltersLabel = this.selectedVendors.length + ' vendors selected';

      if (this.selectedVendors.length === this.vendors.length) {
        this.orderFilter.vendors = undefined
        this.vendorFiltersLabel = 'Filter Vendors';
      }
    }

    if (this.selectedStatuses) {
      this.orderFilter.statuses = this.selectedStatuses.map(t => t.id);
      this.statusesIds = [...this.orderFilter.statuses];

      this.statusesFiltersLabel = this.selectedStatuses.length + ' statuses selected';

      if (this.selectedStatuses.length === this.statuses.length) {
        this.orderFilter.statuses = undefined
        this.statusesFiltersLabel = 'Order Statuses';
      }
    }

    if (this.ordersProject) {
      this.orderFilter.project = [this.ordersProject.id]
    }


    this.changeDetectorRef.detectChanges();

    this.ordersLoading = true;

    this.ordersService.getFilteredOrders(this.orderFilter).subscribe(orders => {
      this.openedOrders = [];

      this.ordersToSubmit = orders.content.map(order => ({
        id: order.id,
        order,
        selected: false
      }))

      this.totalRecords = orders.totalElements;

      this.updateCost()
      this.ordersLoading = false;
    })
  }

  projectChange(event) {
    if (event.value as Project) {
      this.ordersProject = event.value;
      this.ordersProjectId = this.ordersProject.id;
    } else {
      this.orderFilter.project = undefined;
      this.ordersProjectId = -1;
    }

    this.updateFilter();
  }

  toggleVendors() {

    if (this.selectedVendors.length === this.vendors.length) {
      this.selectedVendors = [];
    } else {
      this.selectedVendors = [...this.vendors]
    }
    this.updateFilter()
  }

  toggleStatuses() {
    if (this.selectedStatuses.length === this.statuses.length) {
      this.selectedStatuses = [];
    } else {
      this.selectedStatuses = [...this.statuses]
    }
    this.updateFilter()
  }


  orderIsEdited(orderToSubmit: OrderToSubmit) {

    // const tempOrder = Object.assign({}, orderToSubmit.order)

    // delete tempOrder.items;

    this.saveLoading = orderToSubmit.order.id;

    this.ordersService.updateOrderItem(orderToSubmit.order).subscribe(items => {

      orderToSubmit.order.items = items
      this.saveLoading = -1;

      this.updateOrders();
    }, error => {
      this.saveLoading = -1;
      this.updateOrders();
    })
  }

  resetPaginator($event) {
    this.paginator.changePageToFirst($event);
  }

  deleteOrder(order: Order, openedIndex: number) {
    this.deleteLoading = order.id

    this.confirmationService.confirm({
      header: 'Delete Order?',
      message: `Order ${order.number} will be deleted`,
      accept: () => {


        this.ordersService.deleteOrder(order.id).subscribe(emit => {
          this.deleteLoading = -1;

          const fOrder = this.ordersToSubmit.findIndex(orderS => orderS.order.id === order.id)
          // const fOpenedOrder = this.openedOrders.findIndex(openedOrder => openedOrder === openedIndex)

          if (fOrder >= 0) {

            const fOrderIdInOpened = this.openedOrders.findIndex(idx => idx === fOrder)

            if (fOrderIdInOpened >= 0) {
              this.openedOrders.splice(fOrderIdInOpened, 1)
            }

            this.ordersToSubmit.splice(fOrder, 1)

            this.updateOrders();

            // const els = (this.el.nativeElement as HTMLElement).getElementsByClassName('order-tab')
            // els[fOrder].remove()
            //
            // this.openedOrders = [];
          } else {
            this.openedOrders = [];
          }
        }, error => {
          this.deleteLoading = -1;
        })


      },
      reject: () => {
        this.deleteLoading = -1;
      }
    });
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.ordersPerPage = Math.max(this.ordersPerPage, Math.trunc((this.el.nativeElement.offsetHeight - 150) / 45));

      this.getOrders();
    })
  }
}
